import { useState } from 'react';

import Organization from '../utils/workflow/organization';

import { DomuiError, DynamicData } from '@domui-domain/type';

// Custom hook to handle API calls
export const useFetchDistrictOfficers = () => {
  const [data, setData] = useState<DynamicData>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<DomuiError>(null);

  const fetchDistrictOfficers = async (
    orgId: string,
    meetingData: DynamicData
  ) => {
    try {
      if (meetingData) {
        setLoading(true);
        setError(null); // Clear error before new request
        const wfService = new Organization();
        const response = await wfService.fetchDistrictOfficers(
          orgId,
          meetingData
        );
        setData(response);
        setLoading(false);
      }
    } catch (err) {
      setError(err as DomuiError);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, fetchDistrictOfficers };
};
